export const reputationRouteNames = {
  default: 'reputation-v2',
  overview: 'reputation-overview-v2',
  reviewRequest: 'reputation-review-requests-v2',
  reviews: 'reputation-reviews-v2',
  widget: 'reputation-widget-v2',
  settings: 'reputation-settings-v2',
  listing: 'reputation-listing-v2',
  gbp: 'reputation-gbp-v2',
}
